import { FmApi } from '.'

import type { RoomLogs, RoomLogsParams, RoomReportInfo, RoomReportInfoParams } from '~/features/room/report/types'
import { RoomRankParams, RoomRankResponse } from '~/features/room/types'

export const RoomApi = FmApi.injectEndpoints({
  endpoints: (build) => ({
    getReportInfo: build.query<RoomReportInfo, RoomReportInfoParams>({
      query: (params) => ({
        url: '/v2/report/live-info',
        params,
      }),
    }),
    getChatroomLogs: build.query<RoomLogs, RoomLogsParams>({
      query: (params) => ({
        url: `/v2/chatroom/logs/${params.room_id}`,
        params: {
          start_date: params.start_date,
          end_date: params.end_date,
          p: params.p,
        },
      }),
    }),
    getChatroomRank: build.query<RoomRankResponse, RoomRankParams>({
      query: ({ roomId, type = 0, p, pagesize }) => ({
        url: `/v2/chatroom/rank/${roomId}`,
        params: {
          type,
          p,
          pagesize,
        },
      }),
    }),
  }),
}).endpoints
